import React, {useContext, useEffect, useMemo, useState} from 'react';
import { withRouter } from 'react-router-dom';
import {Formik} from 'formik';
import { AuthContext, UsersContext } from 'contexts';
import userValidations from 'utils/userValidations';
import { PageContainer } from 'layouts';
import EditUserForm from './EditUserForm';
import RolesPresenter from './RolesPresenter';


const EditUser = (props) => {
  const { actions: authActions } = useContext(AuthContext);
  const { actions, state } = useContext(UsersContext);

  const [initialValues, setInitialValues] = useState(null);
  const presenter = useMemo(() => new RolesPresenter(), []);

  useEffect(() => {
    if (!state.users.length) {
      actions.getUsers();
    }
  }, [actions, state.users.length]);

  useEffect(() => {
    (async () => {
      const user = await actions.getUserById(props.match.params.id);
      if (user) {
        setInitialValues({
          email: user.email,
          password: user.password,
          roles: user.roles,
        });
      }
    })();
  }, [actions, setInitialValues, props.match.params.id]);

  const onSubmit = async ({ email, password, roles }, formik) => {
    const data = Object.assign(
      { email, roles },
      password ? { password } : null
    );
    try {
      await actions.updateUser(props.match.params.id, data);
      await authActions.fetchRoles();
      props.history.push('/users');
    } catch (e) {
      formik.setErrors({[e.key]: true});
    }
  };

  return (
    <PageContainer component="main" maxWidth="sm">
      {initialValues ? (
        <Formik
          initialValues={initialValues}
          validationSchema={userValidations.editUser}
          onSubmit={onSubmit}
        >
          {(formikProps) => {
            const { roles } = formikProps.values;
            const handleChange = (event) => {
              const {name, value} = event.target;
              if (name === 'roles') {
                formikProps.setValues({
                  ...formikProps.values,
                  roles: presenter.normalizeRoles(value, roles)
                });
              } else {
                formikProps.handleChange(event);
              }
            }
            return (<EditUserForm {...formikProps} handleChange={handleChange}/>);
          }}
        </Formik>
      ) : (
        'loading user data'
      )}
    </PageContainer>
  );
};

export default withRouter(EditUser);
